<div class="flex flex-col w-[87px] min-h-screen h-full">
  <div class="h-[60px] bg-emerald-500 flex items-center justify-center">
    <lib-petronas-icon />
  </div>

  <div class="w-full bg-emerald-500 min-h-screen h-full">
    <span *ngFor="let item of items | visibleSelection">
      <a *ngIf="item.path.startsWith('http'); else internalLink"
         [href]="item.path"
         class="flex flex-col items-center justify-center h-[76px] bg-green-temp-green py-[16px] px-[4px]">
        <lib-icon [name]="item.icon" />
        <span
              class="heading-12 inline-block mt-[4px] text-white text-center">{{item.label}}</span>
      </a>
      <ng-template #internalLink>
        <a [routerLink]="item.route"
           [routerLink]="item.path"
           routerLinkActive="bg-emerald-600"
           class="flex flex-col items-center justify-center h-[76px] bg-green-temp-green py-[16px] px-[4px]">
          <lib-icon [name]="item.icon" />
          <span
                class="heading-12 inline-block mt-[4px] text-white text-center">{{item.label}}</span></a>
      </ng-template>

    </span>

  </div>
</div>
